import React, { useRef } from "react";
import AsyncSelect from "react-select/async";
import config from "../config";

const CommonAsyncSelect = React.forwardRef((props, ref) => {
  const { loadOptions, debounceTime = config.debounceTime || 500, ...rest } = props;
  const timerRef = useRef(null);

  const internalLoadOptions = (inputValue, callback) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      loadOptions(inputValue, callback);
    }, debounceTime);
  };

  return (
    <AsyncSelect
      ref={ref}
      loadOptions={internalLoadOptions}
      {...rest}
    />
  );
});

export default CommonAsyncSelect;
